<template>
  <v-app>
    <app-snackbar
      :text="snackBarText"
      :show.sync="snackbar"
      :color="snackbarColor"
      :timeOut="timeOut"
    ></app-snackbar>
    <v-container class="pass-recovery">
      <v-layout row>
        <v-flex xs12 sm6 offset-sm3>
          <v-container class="medium-div">
            <v-container class="without-padding container-img">
              <v-img :src="require('../../assets/logoPonce.png')" />
            </v-container>
            <p class="text-title">{{$t('PassRecovery.forgottenPassword')}}</p>
            <div v-if="recoveryEmailSent">
              <div class="recovery-message" v-html="recoveryMessage()"></div>
              <v-layout class="div-reset-password" row>
                <a @click="signIn" class="text-reset-password"
                  ><u>{{$t('PassRecovery.signIn')}}</u></a
                >
              </v-layout>
            </div>
            <v-form v-else v-model="validInput" @submit.prevent="onPassRecovery">
              <v-layout row>
                <v-text-field
                  class="input-email"
                  prepend-inner-icon="mail"
                  name="email"
                  :label="$t('PassRecovery.email')"
                  id="email"
                  v-model="email"
                  type="email"
                  color="#0098E1"
                  :rules="$ponceConfig.emailRules"
                  required
                ></v-text-field>
              </v-layout>
              <v-layout row class="submit-layout">
                <v-flex xs12>
                  <div class="text-center">
                    <v-btn class="submit-btn" block color="info" type="submit">
                      {{$t('PassRecovery.sendRecoveryLink')}}</v-btn
                    >
                  </div>
                </v-flex>
              </v-layout>
              <v-layout class="div-reset-password" row>
                <a @click="signIn" class="text-reset-password"
                  ><u>{{$t('PassRecovery.signIn')}}</u></a
                >
              </v-layout>
            </v-form>
            <div class="bottom-div">
              <p class="bottom-text">PONCE</p>
            </div>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import { auth } from '@/plugins/firebase'
import { parsePhoneNumberForWaMe } from '@/lib/helpers'

export default {
  data () {
    return {
      email: '',
      snackbar: false,
      snackBarText: '',
      snackbarColor: '',
      validInput: '',
      timeOut: 10000,
      recoveryEmailSent: false
    }
  },
  created () {
    if (this.$store.getters.userAuth) {
      this.$router.push('/dashboard')
    }
  },
  methods: {
    signIn () {
      this.$router.push({ name: 'Signin' })
    },
    recoveryMessage () {
      const contactSupportText = this.$t('PassRecovery.contactSupport')
      const supportPhone = process.env.VUE_APP_SUPPORT_PHONE
      
      let supportLink = contactSupportText
      if (supportPhone && typeof supportPhone === 'string' && supportPhone.trim()) {
        const phoneNumber = parsePhoneNumberForWaMe(supportPhone)
        supportLink = `<a href="https://wa.me/${phoneNumber}" target="_blank" class="support-link">${contactSupportText}</a>`
      }
      
      const firstParagraph = this.$t('PassRecovery.recoveryEmailSent')
      const secondParagraph = this.$t('PassRecovery.recoveryEmailSentSecond', { contactSupport: supportLink })
      return `${firstParagraph}<br><br>${secondParagraph}`
    },
    onPassRecovery () {
      if (!this.$store.getters.isOnline) {
        this.snackbar = true
        this.snackBarText = this.$t('PassRecovery.noConnection')
        this.snackbarColor = 'red'
        return
      }
      if (this.validInput) {
        auth.languageCode = 'ES_es'
        auth.sendPasswordResetEmail(this.email).then(() => {
          this.recoveryEmailSent = true
        })
        .catch(() => {
          // Always show success message regardless of error
          this.recoveryEmailSent = true
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// PassRecovery.vue?004d3f72